import React, { createContext, useContext, useState, useEffect } from 'react';

const ChatContext = createContext();

export const useChat = () => {
  const context = useContext(ChatContext);
  if (!context) {
    throw new Error('useChat must be used within a ChatProvider');
  }
  return context;
};

export const ChatProvider = ({ children }) => {
  const [unreadCount, setUnreadCount] = useState(0);
  const [chats, setChats] = useState([]);

  // TODO: Fetch chats from API and count unread messages
  useEffect(() => {
    // fetchChats().then(data => {
    //   setChats(data);
    //   const unread = data.reduce((sum, chat) => sum + (chat.unreadCount || 0), 0);
    //   setUnreadCount(unread);
    // });
  }, []);

  const updateUnreadCount = (count) => {
    setUnreadCount(count);
  };

  const value = {
    unreadCount,
    chats,
    setChats,
    updateUnreadCount,
  };

  return <ChatContext.Provider value={value}>{children}</ChatContext.Provider>;
};
